export default "__VITE_ASSET__Drlh6Hxt__"